// extracted by mini-css-extract-plugin
export default {"prompt":"RatingPrompt_prompt__k-d7q","line":"RatingPrompt_line__QcjOU","compact":"RatingPrompt_compact__ZotjG"};